export const IFRAME_FILE = 'silent-refresh.html';
export const TIMEOUT_FACTOR_INTERVAL = [0.005, 0.95];
